import React from 'react';

function About() {
  return (
    <div className="content-wrapper">
      <div className="main-content">
        <div className="about-container" style={{ textAlign: 'center' }}>
          <h2 className="blog-heading">About Us</h2>
          <p>
            Movie Identifier helps you find the name of a movie from a short video clip or link.
            Our goal is to make identifying films fast and effortless using modern computer vision.
          </p>
          <p>
            Paste a link to a short video or upload a small clip or image, and we will try to
            detect the movie and show useful details like the title, year, director and actors.
          </p>
          <p>
            Have feedback or ideas? Contact us at
            {' '}<a href="mailto:letmeplzdoit@gmail.com">letmeplzdoit@gmail.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;





